import * as msdk from 'flarum/common/utils/madk';

// Credit: https://stackoverflow.com/a/30810322
const fallbackCopyTextToClipboard = (text) => {
  //alert('success1111');
  var textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  document.execCommand('copy');

  //alert('success222');

  document.body.removeChild(textArea);
};

export default function copyTextToClipboard(text) {
  /*if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }

  navigator.clipboard.writeText(text);*/

  fallbackCopyTextToClipboard(text);
}
